// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__aBZ38","summary":"CartItem_summary__5wmks","price":"CartItem_price__hG-kl","amount":"CartItem_amount__MUwCX","actions":"CartItem_actions__kxqGn"};